import { useCallback } from "react"
import { useClient } from "urql"

import type { InventoryLotReference } from "../../../types"

import type { Product, ProductTestListSuccess } from "@/graphql/codegen/graphql"
import { GetExistingProductTestListDocument } from "@/graphql/codegen/graphql"

interface UseAdjustmentLotValidationReturn {
  validateLotsTested: (lots: InventoryLotReference[], product: Product) => Promise<InventoryLotReference[]>
}

export const useAdjustmentLotValidation = (): UseAdjustmentLotValidationReturn => {
  const client = useClient()

  const validateLotsTested = useCallback(
    async (lots: InventoryLotReference[], product: Product): Promise<InventoryLotReference[]> => {
      const untestedLots: InventoryLotReference[] = []

      for (const lot of lots) {
        const result = await client
          .query(GetExistingProductTestListDocument, {
            input: {
              filter: {
                productId: product.productId,
                lotNumber: lot.lotNumber,
                batchNumber: lot.batchNumber,
              },
            },
          })
          .toPromise()

        if (result.data?.productTest.list.__typename === "ProductTestListSuccess") {
          const productTests = (result.data.productTest.list as ProductTestListSuccess).productTests
          if (productTests.length === 0) {
            untestedLots.push(lot)
          }
        }
      }

      return untestedLots
    },
    [client]
  )

  return { validateLotsTested }
}
